import { useMemo } from 'react';
import TimelineGroups from './timeline';
import { resolveActivityMeta } from './activityMeta';

/* Strip any HTML tags so activity comments render as clean plain text. */
function toPlainText(html = '') {
  if (typeof document === 'undefined') return String(html);
  const holder = document.createElement('div');
  holder.innerHTML = html;
  return holder.textContent || holder.innerText || '';
}

const sampleActivity = [
  {
    id: 'a1',
    activityTime: new Date().toISOString(),
    activityComments: 'Job <b>created</b> and assigned to the recruitment team.',
  },
  {
    id: 'a2',
    activityTime: new Date(Date.now() - 2 * 86400000).toISOString(),
    activityComments: 'Status changed to <b>Active</b>.',
  },
];

export default function ActivityTab({ activity, grouped = true }) {
  const rows = useMemo(() => {
    const source = Array.isArray(activity) ? activity : sampleActivity;
    return [...source].sort((left, right) => {
      const leftTime = new Date(
        left?.activityTime ?? left?.activityDateTime ?? left?.performedAt ?? left?.createdAt ?? left?.updatedAt ?? 0,
      ).getTime();
      const rightTime = new Date(
        right?.activityTime ?? right?.activityDateTime ?? right?.performedAt ?? right?.createdAt ?? right?.updatedAt ?? 0,
      ).getTime();
      return (Number.isNaN(rightTime) ? 0 : rightTime) - (Number.isNaN(leftTime) ? 0 : leftTime);
    });
  }, [activity]);

  return (
    <div className="znx-an-body">
      <div className="znx-an-scroll">
        <TimelineGroups
          rows={rows}
          grouped={grouped}
          getTime={(row) => row.activityTime ?? row.createdAt}
          getKey={(row, index) => row.id ?? row._id ?? index}
          emptyText="No activity here."
          getMeta={(row) => resolveActivityMeta(row, row.activityComments)}
          renderBody={(row) => {
            const meta = resolveActivityMeta(row, row.activityComments);
            return (
              <div className="znx-an-comment">
                <span className={`znx-an-tag znx-an-tag--${meta.tone}`}>{meta.label}</span>
                {toPlainText(row.activityComments)}
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}
